import TextField from "@mui/material/TextField";
import type {Visitor} from "../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITOR_PROFILE} from "../../../locales/components/namespaces";
import useExhibitionAction from "../../../hooks/exhibitions/useExhibitionAction";
import FormControl from "@mui/material/FormControl";
import {FormHelperText, InputLabel, ListItem, OutlinedInput, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import {useCategories} from "../../../hooks/categories/useCategories";
import {ErrorMessage} from "formik";

type Props = {
    exhibitionId: string,
    visitor?: Visitor,
    onChange?: Function
}

const ChangeVisitorCharacterization = (props: Props) => {
    const {onChange, visitor, exhibitionId, selected, formik, required, shrink = true} = props
    const {t} = useTranslation(EXHIBITOR_PROFILE)
    const {loading, categories} = useCategories(exhibitionId)
    const {updateVisitor} = useExhibitionAction()
    const onCharacterizationChange = (event) => {
        const value = event.target.value
        if (visitor) {
            updateVisitor(exhibitionId, visitor.id, {
                characterization: value
            })
        } else {
            onChange(categories.find(c => c.id === value))
        }
    }

    return (
        <FormControl
            fullWidth
            size={"small"}
            error={
                formik.touched["characterization"] &&
                Boolean(formik.errors["characterization"])
            }
        >
            <TextField
                select
                name={'characterization'}
                value={selected}
                label={t("Characterization")}
                onChange={onCharacterizationChange}
                onBlur={formik.handleBlur}
                fullWidth
                size={"small"}
                variant={'filled'}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            >
                <MenuItem dense value="">
                    <em>{t('None')}</em>
                </MenuItem>
                {!loading && categories.map(c => (
                    <MenuItem
                        dense
                        key={c.id}
                        value={c.id}
                    >
                        <ListItem component={"div"}>
                            {c.description}
                        </ListItem>
                    </MenuItem>
                ))}
            </TextField>
            <FormHelperText>
                <ErrorMessage name={"characterization"}/>
            </FormHelperText>
        </FormControl>
    )
}

export default ChangeVisitorCharacterization
